import { render, staticRenderFns } from "./DetailItemReceipt.vue?vue&type=template&id=6bd8ee88&scoped=true"
import script from "./DetailItemReceipt.vue?vue&type=script&lang=js"
export * from "./DetailItemReceipt.vue?vue&type=script&lang=js"
import style0 from "./DetailItemReceipt.vue?vue&type=style&index=0&id=6bd8ee88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8ee88",
  null
  
)

export default component.exports